import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'

export const getCanaryRoutingStatus = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getCanaryRoutingStatus()
}

export const postCanaryRoutingCheck = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).postCanaryRoutingCheck()
}

// Do Not Remove this line ===@import api client===
